// extracted by mini-css-extract-plugin
module.exports = {"link":"LinkItem_link__xy2C3","icon":"LinkItem_icon__F8Ean","external":"LinkItem_external__uNo0T","item":"LinkItem_item__iyFED"};